import apiClient from './client';

export const calendarApi = {
  generateToken: async (): Promise<{ feed_url: string; token: string }> => {
    const response = await apiClient.post<{ feed_url: string; token: string }>('/calendar/generate-token');
    return response.data;
  },
};
